import { AbstractRenderer, BusinessComponent, BusinessComponentOptions } from '@blk/simba';
import { InjectConfig, SharedConfigKey } from '@ddt-web/config-layer';
import { InjectQueryParam } from '@ddt-web/generic-utils';
import { DEFAULT_DISCLOSURE_TEXT_CLASSES } from '@ddt-web/pdf-utils';
import { PortfolioIdUtil } from '@ddt-web/portfolio-data';
import { SharedQueryParamKey } from '@ddt-web/url';

import { DisclosureComponent } from './disclosure-component';

export class TpmDisclosureComponent extends BusinessComponent {
	@InjectQueryParam(SharedQueryParamKey.PORTFOLIOS) private readonly portfolios: string[];

	@InjectConfig(SharedConfigKey.ENABLE_TPM_FOR_DOT_COM) private readonly enableTpmDotCom: boolean = false;

	constructor(
		name: string,
		private isSnapshot: boolean = false,
		private constraints?: any
	) {
		super(name, 'TpmDisclosureComponent', BusinessComponentOptions.merge({ visible: true }));
	}

	public buildComponent(): AbstractRenderer<SVGGElement>[] {
		const panels: AbstractRenderer<SVGGElement>[] = [];

		if (!this.enableTpmDotCom) {
			return panels;
		}

		let dcrKey, defaultText = '';

		const isThirdPartyModel = this.portfolios?.some(portfolioId => PortfolioIdUtil.isThirdPartyModel(portfolioId));
		if (!isThirdPartyModel) {
			return [];
		}

		if (this.isSnapshot) {
			dcrKey = 'SNAPSHOT_TPM_DISCLOSURE';
			defaultText = '† Models with a dagger in the name are non-BlackRock Models. ' +
				'BlackRock is not responsible for the accuracy, oversight or review, including with respect to ' +
				'the underlying methodology, of non-BlackRock model portfolio data that is provided to BlackRock by third parties';
		} else {
			dcrKey = 'SHORT_TPM_DISCLOSURE';
			defaultText = '† Non-BlackRock Model';
		}

		panels.push(
			new DisclosureComponent(
				dcrKey,
				defaultText,
				undefined,
				this.constraints || { marginTop: 5 },
				DEFAULT_DISCLOSURE_TEXT_CLASSES
			)
		);

		return panels;
	}

}
